import { Alert, Button } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const StyledAlert = styled(Alert)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['02']};
  min-width: fit-content;

  svg {
    height: ${({ theme }) => theme.size.icon.small};
    width: ${({ theme }) => theme.size.icon.small};
  }
`
